interface AskDynamoFollowUpSuggestionsProps {
  questions: string[]
  onSelect: (text: string) => void
  disabled?: boolean
}

export function AskDynamoFollowUpSuggestions({
  questions,
  onSelect,
  disabled = false,
}: AskDynamoFollowUpSuggestionsProps) {
  if (questions.length === 0) return null

  return (
    <section
      className="mt-4 rounded-2xl border border-[var(--color-ask-dynamo)]/15 bg-gradient-to-br from-[var(--color-ask-dynamo-surface)]/80 to-white/70 p-5"
      aria-labelledby="ask-dynamo-follow-up-heading"
    >
      <h2
        id="ask-dynamo-follow-up-heading"
        className="text-lg font-semibold text-[var(--color-text-primary)]"
      >
        You might also be wondering...
      </h2>
      <ul className="mt-4 flex flex-col gap-2">
        {questions.map((question) => (
          <li key={question}>
            <button
              type="button"
              onClick={() => onSelect(question)}
              disabled={disabled}
              className="block w-full rounded-lg border border-white/80 bg-white/70 px-3 py-2.5 text-left text-sm text-[var(--color-text-primary)] transition hover:bg-white disabled:cursor-not-allowed disabled:opacity-50"
            >
              {question}
            </button>
          </li>
        ))}
      </ul>
    </section>
  )
}
